'use strict';

var FaresOptimizerAnalysisDirective = function FaresOptimizerAnalysisDirective() {
  return {
    restrict: 'E',
    controller: 'FaresOptimizerAnalysisController',
    replace: true,
    template: require('../templates/fares-optimizer-analysis.html'),
    scope: true,
    link: function link($scope) {
      $scope.$on('search-criteria:searchChangeEvent', $scope.reloadFOScreen);
    }
  };
};
FaresOptimizerAnalysisDirective.$inject = [];
module.exports = FaresOptimizerAnalysisDirective;